
// Google Sheet Module State
const state = {
  collection: [],
  current: {},
  fetching: false,
  api_loaded: false,
  currentSheet: {}
}

export default state



// WEBPACK FOOTER //
// ./src/store/google_sheet/state.js